import type { CSSProperties, FC } from 'react';

type DiffHighlightProps = {
	text: string;
	added?: boolean;
	removed?: boolean;
};
export const DiffHighlight: FC<DiffHighlightProps> = ({
	text,
	added,
	removed
}) => {
	const style: CSSProperties = {};
	if (added) {
		style.backgroundColor = 'rgba(0,255,0,0.3)';
		style.fontWeight = 'bold';
	} else if (removed) {
		style.backgroundColor = 'rgba(255,0,0,0.3)';
	}
	return <span style={style}>{text}</span>;
};
